import { isObject } from 'utils/object/is-object';

type Predicate<T> = (first: T, second: T) => boolean;

/**
 * Exclude the intersection of two arrays from the first array.
 */
export function excludeIntersection<T>(
  first: T[],
  second: T[],
  { isDuplicateWhen }: { isDuplicateWhen?: Predicate<T> } = {},
): T[] {
  const newSet = new Set(first);

  second.forEach((entry) => {
    if (isObject(entry) && isDuplicateWhen) {
      const equivalentEntryInFirst = first.find((entryInFirst) =>
        isDuplicateWhen(entryInFirst, entry),
      );

      if (equivalentEntryInFirst) {
        newSet.delete(equivalentEntryInFirst);
      }

      return;
    }

    newSet.delete(entry);
  });

  return [...newSet];
}
